import React
from "react";


//========================================================
// Eva Input
//========================================================

export default function EvaInput({
    message,
    setMessage,
    thinking,
    listening,
    speaking,
    voiceConversationActive,
    onSend,
    onToggleMicrophone
})
{

    //----------------------------------------------------
    // Key Down
    //----------------------------------------------------

    const handleKeyDown =
        event =>
        {

            if (
                event.key === "Enter" &&
                !event.shiftKey
            )
            {

                event.preventDefault();


                onSend();

            }

        };


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (

        <div
            className="eva-chat-input-area"
        >

            <div
                className="eva-chat-input-shell"
            >

                <textarea
                    value={message}

                    onChange={
                        event =>
                            setMessage(
                                event.target.value
                            )
                    }

                    onKeyDown={
                        handleKeyDown
                    }

                    placeholder={
                        listening
                            ?
                            "Listening..."
                            :
                            speaking
                                ?
                                "Eva is speaking..."
                                :
                                "Ask Eva something..."
                    }

                    rows={1}

                    disabled={
                        thinking
                    }
                />


                {/*========================================
                    Microphone
                ========================================*/}

                <button
                    className={
                        "eva-chat-microphone " +
                        (
                            voiceConversationActive
                                ?
                                "eva-chat-microphone-listening"
                                :
                                ""
                        )
                    }

                    onClick={
                        onToggleMicrophone
                    }

                    type="button"

                    title={
                        voiceConversationActive
                            ?
                            "End voice conversation"
                            :
                            "Start voice conversation"
                    }
                >

                    🎙

                </button>


                {/*========================================
                    Send
                ========================================*/}

                <button
                    className="eva-chat-send"

                    onClick={
                        onSend
                    }

                    disabled={
                        thinking ||
                        !message.trim()
                    }

                    type="button"
                >
                    ➜
                </button>

            </div>


            <div
                className="eva-chat-hint"
            >

                {
                    listening
                        ?
                        "Listening... pause when you've finished"
                        :
                        speaking
                            ?
                            "Eva is speaking..."
                            :
                            voiceConversationActive
                                ?
                                "Voice conversation active"
                                :
                                "Eva is powered by OmniScan AI"
                }

            </div>

        </div>

    );

}